
import { Placement } from '@post-office/placements-frontend/search-page-results-quick-find';
export default Placement;
